import { Injectable } from '@angular/core';
import { RestService } from 'src/app/shared/services/rest-service';
import { Observable } from 'rxjs';
import { ICompanySearchResponse } from 'src/app/core/models/i-company-search-response';
import { IPersonSearchResponse } from 'src/app/core/models/i-person-search-response';

@Injectable({
  providedIn: 'root',
})
export class CompanyAndPeopleService {
  private readonly BASE_CONTENT_ROUTE = `api`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_CONTENT_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getCompanies$(searchText: string): Observable<ICompanySearchResponse> {
    const params = this.restService.buildHttpParamsObject({
      searchText,
    });

    return this.restService.get$<ICompanySearchResponse>(
      this.BUILD_HTTP_ROUTE('companies'),
      {
        params,
      },
    );
  }

  getPeople$(searchText: string): Observable<IPersonSearchResponse> {
    const params = this.restService.buildHttpParamsObject({
      searchText,
    });

    return this.restService.get$<IPersonSearchResponse>(
      this.BUILD_HTTP_ROUTE('people'),
      {
        params,
      },
    );
  }
}
